/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteTriggeredActionRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'
import {DeleteTriggeredActionResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/triggered_action_messages.pb'


export const deleteTriggeredAction = (request: DeleteTriggeredActionRequest, options?: CashRequestOptions) => post<DeleteTriggeredActionRequest, DeleteTriggeredActionResponse>("/cash-app/goose-cash/v3/delete-triggered-action", request, {...options, rejectOnError: true })